module.exports = __webpack_public_path__ + "static/img/3.1a2a509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity_icon/3.png
// module id = vfr7
// module chunks = 4